<template>
<div>
 

    <vue-form @submit.prevent="register" name="registerform" v-model="clientInfo" class=''>

        <div v-if="this.error" class='alert alert-danger'>
            {{ this.error }}
        </div>

        <div class="row">
                <vue-field class='col-12' type="string" ref="cpf" name="cpf" label="CPF" required :validations="['cpf']"></vue-field>
                <vue-field  class='col-12 col-lg-6' type="string" name="name" label="Nome Completo" required></vue-field>
                <vue-field  class='col-12 col-lg-6' type="string" name="email" label="Email" required :validations="['email']"></vue-field>
                <vue-field  class='col-12 col-lg-6' type="age" name="birthday" label="Data de Nascimento" required ></vue-field>
                <vue-field  class='col-12 col-lg-6' type="string" name="telephone" label="Telefone" required ></vue-field>
                <vue-field  class='col-12 col-lg-6' type="address" name="address" label="Endereço" />
                <vue-field  class='col-12 col-lg-6' type="password" name="password" label="Senha" required ></vue-field>

                <div class="col-12">
                  <input  class='btn btn-primary' type="submit" value="Registre-se">
                </div>
        </div>
    </vue-form>
</div>
</template>

<script>

import validadeFormMixins from "@/mixins/validateForms"
import api from "@/api"

export default {

    mixins:[validadeFormMixins],
    data(){
        return{
            clientInfo:{},
            error:false,
            erromsg:'',
        }
    },

    watch:{
      
    },

    computed:{
        user:function(){
            return this.$store.getters.user
        }
    },

    methods:{

       
        register:async function(){
            this.$emit('registerStart', {cpf:this.clientInfo.cpf} )
            this.error = false;
            var formValid = await this.validateForms();
            if(!formValid) return
            let response = await this.$store.dispatch('register', this.clientInfo )
            if(response.error){
                    this.error = response.data.error.message;
                    return false;
            }else{
                this.error = false;
                this.$emit('logged',this.user)
                return true;
            }
        },


        formsOk: async function(){

            let response;

            if(this.user && this.edit == false){
                //update user
                return true
            }
            
            if(this.user && this.edit){
                this.error = false
                //try to relogin
                response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
                 if(response.error){
                    this.error = response.data.error.message;
                    return false;
                 }

                //if ok, save data
                response = await this.$store.dispatch('updateUser', this.clientInfo )
                 if(response.error){
                    this.error = response.data.error.message;
                    return false;
                 }
                 return true;
            }
            
            if(this.userWithDataExist){
                response = await this.$store.dispatch('login', { cpf:this.clientInfo.cpf, password:this.clientInfo.password } ) 
            
            }else{
                var formValid = await this.validateForms();
                if(formValid){
                    if(this.userWithDataExist){
                        
                    }else{
                        response = await this.$store.dispatch('register', this.clientInfo )
                    }
                }else{
                    return false
                }
            }

            if(response.error){
                    this.error = response.data.error.message;
                    return false;
            }else{
                return true;
            }

        }
    }

}
</script>

<style>

</style>
